import React, { Component, useCallback } from 'react';
import { connectInfiniteHits } from 'react-instantsearch-dom';
import { TypesenseProduct, TypesenseProductEvent } from '../../models/product';
import Lottie from 'react-lottie';
import noItem from "../../public/lottie/13525-empty.json";
import OpportunityCard from './opportunity-card';
import { TypesenseOpportunity } from '../../models/user';

type MyProps = { hits: TypesenseOpportunity[], hasMore: boolean, refineNext: () => void };
type MyState = { timer: number, loadAfterHundered: boolean, sort: Sort };

type Sort = { by: string, direction: string }

class InfiniteHitsOpportunitys extends Component<MyProps, MyState> {
    sentinel = null;
    observer = null;
    myInterval = null;


    state = { loadAfterHundered: false, timer: 0, sort: { by: "date", direction: "asc" } };

    onSentinelIntersection = entries => {
        const { hasMore, refineNext, hits } = this.props;
        entries.forEach(entry => {
            if (entry.isIntersecting && hasMore && this.state.loadAfterHundered === false) {
                refineNext();
            } else if (hits?.length % 100 === 0 && hits?.length != 0) {
                this.setState({ loadAfterHundered: true });
            }
        });
    };


    componentDidMount() {
        this.myInterval = setInterval(() => {
            const { timer } = this.state

            if (timer < 5) {
                this.setState(({ timer }) => ({
                    timer: timer + 1
                }))
            }
        }, 1000)

        this.observer = new IntersectionObserver(this.onSentinelIntersection);
        this.observer.observe(this.sentinel);
    }


    componentWillUnmount() {
        clearInterval(this.myInterval)
        this.observer.disconnect();
    }

    render() {
        const hits = this.props.hits as TypesenseOpportunity[];
        return (
            <div className="">
                <ul className=" m-0 p-0 opportunity-grid">
                    {hits.map(hit => (
                        // hit?.status === "approved" &&
                        <li key={hit.id} className="">
                            <OpportunityCard opportunity={hit} />
                        </li>
                    ))}
                    {hits.length === 0 && this.state.timer >= 5 &&
                        <div className='col-12 '>
                            <h1 className='text-center'>No Item Found!</h1>
                            <Lottie heigth={0} width={450} options={{ loop: true, autoplay: true, animationData: noItem }} />
                        </div>}

                    {hits.length === 0 && this.state.timer < 5 &&
                        <div className='col-12 '>
                            <h1 className='text-center'>Searching Items For You!</h1>
                            <Lottie heigth={0} width={450} options={{ loop: true, autoplay: true, animationData: noItem }} />
                        </div>}


                    <li
                        className="ais-InfiniteHits-sentinel"
                        ref={c => (this.sentinel = c)}
                    />


                </ul>
                {this.state.loadAfterHundered === true ?
                    <div className="my-5 col-sm-4 mx-auto">
                        <button className="btn border-dark btn-dark bg-white text-dark w-100 py-2 px-5" onClick={() => {
                            this.setState({ loadAfterHundered: false });
                            this.props.refineNext();
                        }}>See more</button>
                    </div>

                    : null
                }
            </div>
        );
    }
}

export default connectInfiniteHits(InfiniteHitsOpportunitys);
